import script from "./DeletionPolicy.vue?vue&type=script&setup=true&lang=js"
export * from "./DeletionPolicy.vue?vue&type=script&setup=true&lang=js"

import "./DeletionPolicy.vue?vue&type=style&index=0&id=11a3daf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11a3daf4"]])

export default __exports__